import React from 'react';

function WhyChoose({ heading, subheading, benefits }) {

    return (
        <div className="mb-16" >
            <h2 className="text-3xl font-bold mb-4 text-center">{heading}</h2>
            <p className="text-gray-600 text-center mb-8">
                {subheading}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {benefits.map((benefit) => (
                    <div key={benefit.id} className="bg-gray-100 p-6 rounded-lg">
                        <div className="flex items-start">
                            <div className="mr-4">
                                {benefit.icon}
                            </div>
                            <div>
                                <h3 className="font-bold text-lg mb-2">{benefit.title}</h3>
                                <p className="text-gray-700">{benefit.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default WhyChoose;